import { useLocation } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';

export default function useIsActivitiesRoot() {
  const { pathname } = useLocation();

  return (
    pathname.endsWith(`/${RoutesEnum.ACTIVITIES}`) ||
    pathname.endsWith(`/${RoutesEnum.ACTIVITIES}/`)
  );
}
